import ReactDOM from 'react-dom/client' // Use 'react-dom/client'
import Swal from 'sweetalert2'
import { Box, Button } from '@mui/material'

// Define the props for the ConfirmationAlert component
interface ConfirmationAlertProps {
  title?: string
  text?: string
  icon?: 'warning' | 'error' | 'success' | 'info' | 'question'
  confirmButtonText?: string
  cancelButtonText?: string
  onConfirm?: () => void
  onCancel?: () => void
}

export const ConfirmationAlert = ({
  title = 'Are you sure?',
  text = 'You won\'t be able to revert this!',
  icon = 'warning',
  confirmButtonText = 'YES',
  cancelButtonText = 'NO',
  onConfirm,
  onCancel,
}: ConfirmationAlertProps): void => {
  // Create a container to hold the React components
  const footer = document.createElement('div')

  // Create a root for the new container
  const root = ReactDOM.createRoot(footer) // Create a root

  // Render the contained buttons to the footer
  root.render(
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem',
      }}
    >
      <Button
        variant='contained'
        id='confirm-button'
        color='primary'
        size='small'
        onClick={() => {
          Swal.close()
          if (onConfirm) onConfirm()
        }}
      >
        {confirmButtonText}
      </Button>
      <Button
        variant='contained'
        id='cancel-button'
        color='error'
        size='small'
        onClick={() => {
          Swal.close()
          if (onCancel) onCancel()
        }}
      >
        {cancelButtonText}
      </Button>
    </Box>,
  )

  Swal.fire({
    title,
    text,
    icon,
    showCancelButton: false, // Hide the default cancel button
    showCloseButton: false, // Hide the default close button
    confirmButtonText: ' ', // Remove the default confirm button text
    cancelButtonText: ' ', // Remove the default cancel button text
    customClass: {
      container: 'swal-toast-container',
      footer: 'custom-footer',
    },
    footer: footer, // Add the custom footer
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      // Hide default buttons if they are still visible
      const confirmButton = Swal.getConfirmButton()
      const cancelButton = Swal.getCancelButton()
      if (confirmButton) confirmButton.style.display = 'none'
      if (cancelButton) cancelButton.style.display = 'none'
    },
  })
}
